<script>
import { BProgress } from "bootstrap-vue";

export default {
  extends: BProgress
};
</script>